import * as actionTypes from './actionTypes';

export const resetPageState = (page: string) => ({
  type: actionTypes.RESET_PAGE_STATE,
  page,
});
